const updateFunc = (controlData) => {
  const sensitivity =
    controlData["sensitivity"] !== undefined ? controlData["sensitivity"] : 95;

  const tp = sensitivity;
  const fn = 100 - sensitivity;
  const bl = 900;

  const jsonTruePositive = { Test: "True positive" };
  const jsonFalseNegative = { Test: "False negative" };
  const jsonBlank = { Test: "" };
  const repeatedTruePositive = Array(tp).fill(jsonTruePositive);
  const repeatedFalseNegative = Array(fn).fill(jsonFalseNegative);
  const repeatedBlank = Array(bl).fill(jsonBlank);
  const calculatedData1 = repeatedTruePositive.concat(repeatedFalseNegative);
  const calculatedData = calculatedData1.concat(repeatedBlank);

  return calculatedData;
};

export default updateFunc;
